"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _draftExtend = require("draft-extend");

var _ContentButton = _interopRequireDefault(require("draft-content-plugins/components/ContentButton"));

var _ContentOutputTypes = require("draft-content-plugins/lib/ContentOutputTypes");

var _KnowledgeArticlesApi = _interopRequireDefault(require("draft-content-plugins/plugins/knowledgeArticles/KnowledgeArticlesApi"));

var _createPluginButton = _interopRequireDefault(require("draft-content-plugins/utils/createPluginButton"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _immutable = require("immutable");

var _react = _interopRequireDefault(require("react"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _underscore = require("underscore");

var _ReferenceObjectTypes = _interopRequireDefault(require("reference-resolvers/constants/ReferenceObjectTypes"));

var _InsertContentDecorator = _interopRequireDefault(require("../../components/InsertContentDecorator"));

var _KnowledgePopoverEmptyState = _interopRequireDefault(require("./popover/KnowledgePopoverEmptyState"));

var KnowledgeArticlesOutputTypes = (0, _immutable.List)([_ContentOutputTypes.RENDERED]);
var KnowledgeArticlesButton = (0, _createPluginButton.default)({
  icon: 'bulb',
  toolTip: _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "draftPlugins.knowledgeArticlesPlugin.tooltip"
  })
});

var _default = function _default(_ref) {
  var _ref$apiClient = _ref.apiClient,
      apiClient = _ref$apiClient === void 0 ? _apiClient.default : _ref$apiClient,
      _ref$dataProp = _ref.dataProp,
      dataProp = _ref$dataProp === void 0 ? _ReferenceObjectTypes.default.KNOWLEDGE_ARTICLES : _ref$dataProp,
      _ref$outputType = _ref.outputType,
      outputType = _ref$outputType === void 0 ? _ContentOutputTypes.RENDERED : _ref$outputType,
      _ref$tracker = _ref.tracker,
      tracker = _ref$tracker === void 0 ? _underscore.identity : _ref$tracker,
      _ref$onInsertContent = _ref.onInsertContent,
      onInsertContent = _ref$onInsertContent === void 0 ? _underscore.identity : _ref$onInsertContent,
      _ref$portalId = _ref.portalId,
      portalId = _ref$portalId === void 0 ? _hubspot.default.get() : _ref$portalId,
      _ref$button = _ref.button,
      button = _ref$button === void 0 ? KnowledgeArticlesButton : _ref$button,
      _ref$onOpenPopover = _ref.onOpenPopover,
      onOpenPopover = _ref$onOpenPopover === void 0 ? function () {} : _ref$onOpenPopover,
      popoverPlacement = _ref.popoverPlacement;
  (0, _invariant.default)(KnowledgeArticlesOutputTypes.includes(outputType), "KnowledgeArticlesPlugin: expected out to be " + KnowledgeArticlesOutputTypes.join(', '));
  var insertSnippetDecoratorConfig = {
    outputType: outputType,
    apiFunctions: (0, _KnowledgeArticlesApi.default)(apiClient)
  };
  return (0, _draftExtend.createPlugin)({
    buttons: button && (0, _InsertContentDecorator.default)((0, _ContentButton.default)({
      dataProp: dataProp,
      tracker: tracker,
      portalId: portalId,
      onInsertContent: onInsertContent,
      Button: button,
      onOpenPopover: onOpenPopover,
      PopoverEmptyState: _KnowledgePopoverEmptyState.default,
      popoverPlacement: popoverPlacement,
      searchPlaceHolder: 'draftPlugins.knowledgeArticlesPlugin.popover.search.placeholder'
    }), insertSnippetDecoratorConfig)
  });
};

exports.default = _default;
module.exports = exports.default;